export class ProductAttributeViewService {
  public contactSales(): void {
    const emailLink = document.createElement('a');
    emailLink.href = 'mailto:rpxsupport@productsup.com';
    emailLink.click();
  }
}
